import { HttpClient } from './httpClient';
import { API_URL } from './RestAPI';
import apiHeaders from './apiHeaders';

const STORE_API = `${API_URL}/stores`;

const getSalesByProduct = (storeId, startDate, endDate) => {
  return HttpClient.get(
    `${STORE_API}/${storeId}/reports/sales-by-product?startDate=${startDate}&endDate=${endDate}`,
    apiHeaders()
  );
};

const getProductBuyers = (storeId, variantId, startDate, endDate) => {
  return HttpClient.get(
    `${STORE_API}/${storeId}/reports/sales-by-product/${variantId}/buyers?startDate=${startDate}&endDate=${endDate}`,
    apiHeaders()
  );
};

const StoreReportApi = { getSalesByProduct, getProductBuyers };

export { StoreReportApi };